import * as React from 'react';
import {
    CreateButton,
    DateField,
    FilterButton,
    List,
    NumberField,
    SearchInput,
    TopToolbar,
    TextField,
    DatagridConfigurable,
    SelectColumnsButton,
    useTranslate,
    FunctionField,
    ReferenceField,
    WithListContext,
    DatagridLoading,
    useNotify,
    Pagination,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';
import { Alert } from '@mui/material';

import CustomStatusField from '../controls/CustomStatusField';
import AnnouncementListAside from './AnnouncementListAside';
// import ProductFullNameField from '../product/ProductFullNameField';
// import SubscriberFullNameField from './SubscriberFullNameField';

const userFilters = [
    <SearchInput source="q" alwaysOn />,
];

const ListActions = () => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        <TopToolbar>
            {isSmall ? <FilterButton /> : null}
            <SelectColumnsButton />
            <CreateButton />
            {/* <ExportButton /> */}
            {/* <ListViewButton /> */}
        </TopToolbar>
    );
};

const UserList = () => {
    const notify = useNotify();
    const handleOnClick = e => {
        e.stopPropagation();
        navigator.clipboard.writeText(e.target.innerText);
        //notify(e.target.innerText + ' kopioitu leikepöydälle.', { type: 'info' });
        notify(
            <Alert severity="info">
                {e.target.innerText} kopioitu leikepöydälle.
            </Alert>
        );
    };
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    const sortable = ['name', 'created', 'creator_name', 'modified', 'modifier_name', 'valid_from', 'valid_until', 'status'];

    const translate = useTranslate();

    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));

    return (
        <List
            filters={isSmall ? userFilters : undefined}
            sort={{ field: 'created', order: 'DESC' }}
            filter={{}}
            perPage={50} 
            pagination={<Pagination rowsPerPageOptions={[10,25,50,100,200,{label:'Kaikki (max 500)', value:500}]} />}
            aside={<AnnouncementListAside />}
            actions={<ListActions />}
        >
            
            <WithListContext render={({ isLoading, isFetching, data }) => (
                isLoading || isFetching ? (<DatagridLoading nbChildren={8} nbFakeLines={8} />) : (<DatagridConfigurable
                //optimized
                omit={['guid']}
                rowClick="edit"
                sx={{
                    '& .column-groups': {
                        md: { display: 'none' },
                        lg: { display: 'table-cell' },
                    },
                }}
            >
                {/* {columns} */}
                <TextField source="guid" key="guid" sortable={sortable.includes('guid')} />
                <TextField source="name" key="name" sortable={sortable.includes('name')} />
                <DateField source="created" key="created" showTime={false} locales="fi-FI" sortable={sortable.includes('created')} />
                {/* <ReferenceField reference="user" source="author.creator" key="creator" sortable={sortable.includes('creator')}>
                    <FunctionField render={record => `${record.public.firstname} ${record.public.lastname}`} />
                </ReferenceField>
                <DateField source="modified" key="modified" showTime={false} locales="fi-FI" sortable={sortable.includes('modified')} />
                <ReferenceField reference="user" source="author.modifier" key="modifier" sortable={sortable.includes('modifier')}>
                    <FunctionField render={record => `${record.public.firstname} ${record.public.lastname}`} />
                </ReferenceField> */}
                <TextField source="creator_name" key="creator_name" sortable={sortable.includes('creator_name')} />
                <DateField source="modified" key="modified" showTime={false} locales="fi-FI" sortable={sortable.includes('modified')} />
                <TextField source="modifier_name" key="modifier_name" sortable={sortable.includes('modifier_name')} />
                <DateField source="valid_from" key="valid_from" showTime={true} locales="fi-FI" sortable={sortable.includes('valid_from')} />
                <DateField source="valid_until" key="valid_until" showTime={true} locales="fi-FI" sortable={sortable.includes('valid_until')} />
                <CustomStatusField source="status" key="status" url="extralist/announcement/statuses" sortable={sortable.includes('status')} />
            </DatagridConfigurable>
            ))} />
        </List>
    );
};

export default UserList;
